import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { memo, useMemo, useCallback } from "react";
import { Switch } from "@mui/material";
import { useField } from "formik";
import { useDeepCompareMemo } from "use-deep-compare";
import { getHasError } from "../../utils/helpers/getHasError.js";
import { useFormHelpers } from "../../utils/hooks/useFormHelpers.js";
import { useSubmitCount } from "../../utils/hooks/useSubmitCount.js";
import { ToggleContainer } from "../../utils/shared/ToggleContainer.js";
import { ToggleFormControlLabel } from "../../utils/shared/ToggleFormControlLabel.js";
import { combinedFields } from "../../utils/yup/main.js";
import { FieldHelperText } from "../field-helper-text/field-helper-text.js";
import { Translate } from "../translate/translate.js";
import "yup";
import "../../utils/fields/personalInformation.js";
import "../../../../../type/Appointment.js";
import "../masked-date-input/masked-date-input.js";
import "react-i18next";
import "react-text-mask";
import "../../utils/entities/Form.js";
import "../../../ana-toolbox/ana-toolbox.js";
import "../../../../../constants/date/date.js";
import "date-fns/fp/format";
import "date-fns/isValid";
import "date-fns/parse";
import "date-fns";
import "../../utils/helpers/toBoolean.js";
import "../../utils/helpers/createFields.js";
import "../../utils/helpers/resetFields.js";
import "../../utils/yup/yup.js";
import "../../../../../utils/pipe.js";
import "date-fns/fp";
import "libphonenumber-js/max";
import "libphonenumber-js/mobile";
import "../../utils/helpers/predicates.js";
import "../../utils/yup/emailValidation.js";
import "../../utils/fields/contactDetails.js";
import "../../utils/helpers/featureFlags.js";
import "../../utils/helpers/getAgeFromBirthday.js";
import "../../utils/yup/buildValidationSchema.js";
import "../../utils/fields/miscellaneous.js";
import "../../utils/fields/insurance.js";
import "../../utils/fields/allergiesAndMedications.js";
import "../../../../../type/Disease.js";
import "../../utils/config/medicaments.js";
import "../../utils/fields/wishesAndExpectations.js";
import "../../utils/fields/consents.js";
import "../../utils/fields/profileInterest.js";
const ToggleFieldBase = memo(
  ({
    className,
    label,
    error,
    helperText,
    ...props
  }) => {
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(ToggleContainer, { className, children: /* @__PURE__ */ jsx(
        ToggleFormControlLabel,
        {
          label: /* @__PURE__ */ jsx(Translate, { children: label }),
          error: Boolean(error),
          labelPlacement: "start",
          control: /* @__PURE__ */ jsx(Switch, { ...props, checked: Boolean(props.value) })
        }
      ) }),
      /* @__PURE__ */ jsx(FieldHelperText, { name: props.name, helperText, error })
    ] });
  }
);
const ToggleField = (props) => {
  const [field, meta] = useField(props.name);
  const submitCount = useSubmitCount();
  const formHelpers = useFormHelpers();
  const hasError = useMemo(() => getHasError(meta, submitCount ?? 1), [meta, submitCount]);
  const memoizedField = useDeepCompareMemo(() => field, [field]);
  const fieldSettings = useMemo(
    () => combinedFields[props.name],
    [props.name]
  );
  const handleChange = useCallback(
    (e) => {
      var _a, _b;
      (_b = (_a = fieldSettings == null ? void 0 : fieldSettings.hooks) == null ? void 0 : _a.beforeChange) == null ? void 0 : _b.call(_a, e.target.checked, formHelpers, e);
      field.onChange({ target: { value: e.target.checked, name: e.target.name } });
    },
    // Ignoring these dependencies to prevent unnecessary re renderes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  return /* @__PURE__ */ jsx(ToggleFieldBase, { error: hasError ? meta.error : void 0, ...memoizedField, ...props, onChange: handleChange });
};
export {
  ToggleField
};
